module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"購入転換力"}}')
  delete Component.options._Ctor
}
